module.exports = __webpack_public_path__ + "assets/to-left.28f307f7.svg";